$shm_media $mol_pop
	uri \
	kind \image
	Anchor <= Preview $mol_button
		hint <= preview_hint \Открыть на весь экран
		sub <= preview_content /
		click? <=> open? null
	bubble_content /
		<= Overlay $mol_view
			event *
				click? <=> close? null
			sub /
				<= Full $mol_view
					sub <= full_content /
				<= Close $mol_button_minor
					hint \Закрыть
					sub /
						<= Close_icon $mol_icon_close
					click? <=> close? null
	Preview_image $mol_image
		uri <= uri
	Preview_video $mol_video_player
		uri <= uri
		autoplay false
		controls false
		muted true
	Full_image $mol_image
		uri <= uri
	Full_video $mol_video_player
		uri <= uri
		autoplay false
		controls true
		muted false
